import React from "react";
import InputComponent from "./InputComponent";
import HeaderComponent from "./HeaderComponent";
function App() {
  return (
    <div className="App">
      <HeaderComponent />
      <InputComponent />
    </div>
  );
}

export default App;
